import { useAuthState } from "@/contexts/AuthContext";
import { isAuthPending, isAuthenticatedUser } from "@/lib/authRouting";

/**
 * Blocks protected page content until auth hydration completes.
 * Reserves vertical space instead of returning null to avoid layout collapse.
 */
export function ProtectedPageGate({ children }) {
    const { user, authPhase, sessionReady } = useAuthState();
    const ready = sessionReady && !isAuthPending(authPhase) && isAuthenticatedUser(user);

    if (!ready) {
        return (
            <div
                className="protected-page-gate w-full min-h-[min(28rem,calc(100vh-8rem))]"
                aria-hidden
                data-testid="protected-page-gate-pending"
            />
        );
    }

    return children;
}
